export default __webpack_public_path__ + "static/media/Icon metro-organization.ed8f6182.svg";